import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-share-modal',
  imports: [],
  templateUrl: './share-modal.component.html',
  styleUrl: './share-modal.component.css'
})
export class ShareModalComponent {
    @Output() close = new EventEmitter<void>();

}
